import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

// We can inject some CSS into the DOM.

const styles = theme => ({
  root: {
    border: '1px solid #c2c2c2',
    borderRadius: '4px',
    backgroundColor: 'transparent',
    color: '#c2c2c2',
    textTransform: 'unset',
    fontWeight: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.colors.white,
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
})

function ClassNames(props) {
  const { className, ...rest } = props
  return (
    <Button
      variant="outlined"
      color="secondary"
      className={`${props.classes.root} ${className}`}
      style={{ ...props.style }}
      {...rest}
    >
      {props.children ? props.children : 'class names'}
    </Button>
  )
}

export default withStyles(styles)(ClassNames)
